import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router/router'
import VueI18n from 'vue-i18n'

// Ready translated locale messages
const messages = {
  ru: {
    menu: {
      about: 'О приложении',
      help: 'Справка',
      close: 'Закрыть'	  
    },
    titles: {
      main: 'Погода и климат ',

      // left drawer
      params: 'Выбор данных',
      control: 'Выбор данных',
      datetime: 'Дата',
      date: 'Дата',
      period: 'Период осреднения',
      confidence: 'Обеспеченность',
      term: 'Час',
      meteo: 'Метео',
      air: 'Кач. воздуха',
      var: 'Показатель',
      layers: 'Слои отображения',
      interp: 'Интерполяция',
      relation: 'Относительно фона',
      rhm: 'Росгидромет',
      netatmo: 'Netatmo',
      level: 'Уровень фильтрации',
      map_transparency: 'Прозрачность карты',

      // bottom panel
      plots: 'Графики',
      scaling: 'Масштабирование',
      series: 'Станции',

      // right panel
      events: 'Метеособытия',
      select: 'Дата и время по UTC+3'
    },
    hints: {

      // left drawer
      first: 'Первый период',
      last: 'Последний период',
      prev: 'Предыдущий период',
      next: 'Следующий период',
      stations: 'Метеостанции',
      stations_background: 'Выбор фоновых станций',
      stations_urban: 'Выбор городских станций',
      fields: 'Метеополя',
      filter: 'Фильтрация Netatmo',

      // bottom panel
      autoscale: 'Масштабировать автоматически',
      reset: 'Сбросить масштаб',
      add: 'Добавить на график',

      // right panel
      eventlist: 'Список событий',
      search: 'Поиск',
      invite: 'Начните ввод для поиска'
    },
    vars: {
      meteo: {
        temperature: 'Температура [℃]',
        humidity: 'Влажность [%]',
        pressure: 'Давление [гПа]',
        cloud: 'Облачность [х/10]',
        wind: 'Ветер [м/с]',
        prec: 'Осадки [мм]',
        pet: 'Комфортность PET [℃]',
        mrt: 'Рад. температура MRT [℃]',
        utci: 'Комфортность UTCI [℃]'
      },
      air: {
        moscow: {
          nh3: 'Аммиак (NH<sub>3</sub>)',
          pm10: 'Взвеш. частицы (PM<sub>10</sub>)',
          pm25: 'Взвеш. частицы (PM<sub>25</sub>)',
          no2: 'Диоксид азота (NO<sub>2</sub>)',
          so2: 'Диоксид серы (SO<sub>2</sub>)',
          o3: 'Озон (O<sub>3</sub>)',
          co: 'Оксид углерода (CO)',
          ch4: 'Метан (CH<sub>4</sub>)',
          h2s: 'Сероводород (H<sub>2</sub>S)',
          no: 'Оксид азота (NO)',
          c6h6: 'Бензол (C<sub>6</sub>H<sub>6</sub>)',
          c10h8: 'Нафталин (C<sub>10</sub>H<sub>8</sub>)',
          c8h8: 'Стирол (C<sub>8</sub>H<sub>8</sub>)',
          c7h8: 'Толуол (C<sub>7</sub>H<sub>8</sub>)',
          c6h5oh: 'Фенол (C<sub>6</sub>H<sub>5</sub>OH)',
          ch2o: 'Формальдегид (CH<sub>2</sub>O)',
        },
        spb: {
          nh3: 'Аммиак (NH<sub>3</sub>)',
          susp_sol: 'Взвеш. вещества (SS)',
          pm10: 'Взвеш. частицы (PM<sub>10</sub>)',
          pm25: 'Взвеш. частицы (PM<sub>25</sub>)',
          no2: 'Диоксид азота (NO<sub>2</sub>)',
          so2: 'Диоксид серы (SO<sub>2</sub>)',
          o3: 'Озон (O<sub>3</sub>)',
          co: 'Оксид углерода (CO)'
        }
      }
    },
    periods: {
      hour: 'Срок',
      day: 'День',
      week: 'Неделя',
      month: 'Месяц',
      year: 'Год'
    },
    aggrunits: [
      { text: 'Исходные данные (3 ч.)', value : 'hour' },
      { text: 'Сутки', value : 'day' },
      { text: 'Неделя', value : 'week' },
      { text: 'Месяц', value : 'month' },
      { text: 'Год', value : 'year' }
    ],
    cities: [
      { text: 'Москвы', value : 'moscow' },
      { text: 'Санкт-Петербурга', value : 'spb' },
    ],
    messages: {
      no_background_data: 'Данные для расчёта фона отсутствуют',
      confidence_hint: 'Уменьшить обеспеченность до {confidence}%, чтобы увидеть данные?',
      yes: 'Да',
    },
            fields: {
      name: 'NAME',
      stname: 'name'
    },
    grades: {
      extreme_heat_stress: 'Экстремальный тепловой стресс',
      very_high_heat_stress: 'Очень высокий тепловой стресс',
      high_heat_stress: 'Высокий тепловой стресс',
      moderate_heat_stress: 'Умеренный тепловой стресс',
      no_thermal_stress: 'Термический комфорт',
      moderate_cold_stress: 'Умеренный холодовой стресс',
      high_cold_stress: 'Высокий холодовой стресс',
      very_high_cold_stress: 'Очень высокий холодовой стресс',
      extreme_cold_stress: 'Экстремальный холодовой стресс'
    },
    pdk: {
      label: 'ПДК (среднесуточная)',
      fraction: 'доля ПДК'
    },
    templates: {
      network: 'Сеть',
      add: 'ДОБАВИТЬ НА ГРАФИК',
      rhm: {
        title: 'Росгидромет',
        units: {
          name: '',
          id: '',
          date: '',
          time: 'ч.',
          temperature: '℃',
          humidity: '%',
          pressure: 'гПа',
          cloud: '/ 10',
          wind: 'м/с',
          prec: 'мм',
          pet: '℃',
          mrt: '℃',
          utci: '℃',
        },
        labels: {
          name: 'Название',
          id: 'Идентификатор',
          date: 'Дата',
          time: 'Время',
          temperature: 'Температура',
          humidity: 'Влажность',
          pressure: 'Давление',
          cloud: 'Облачность',
          wind: 'Ветер',
          prec: 'Осадки',
          pet: 'Комфортность PET',
          mrt: 'Комфортность MRT',
          utci: 'Комфортность UTCI',
        }
      },
      netatmo: {
        title: 'Netatmo',
        units: {
          id: '',
          date: '',
          time: 'ч.',
          temperature: '℃',
          humidity: '%',
          pressure: 'гПа',
        },
        labels: {
          id: 'Идентификатор',
          date: 'Дата',
          time: 'Время',
          temperature: 'Температура',
          humidity: 'Влажность',
          pressure: 'Давление',
        }
      }
    },
  },
  en: {
    menu: {
      about: 'About',
      help: 'Help',
      close: 'Close'
    },
    titles: {
      main: 'Weather and climate of ',
      params: 'Data selection',
      control: 'Data selection',
      datetime: 'Date',
      date: 'Date',
      period: 'Aggregation period',
      confidence: 'Confidence',
      term: 'Hour',
      meteo: 'Meteo',
      air: 'Air Quality',
      var: 'Variable',
      layers: 'Map layers',
      interp: 'Interpolation',
      relation: 'Relative to background',
      rhm: 'Synoptic stations',
      netatmo: 'Netatmo',
      level: 'Filtering level',
      map_transparency: 'Basemap transparency',

      // bottom panel
      plots: 'Plots',
      scaling: 'Zoom',
      series: 'Stations',

      // right panel
      events: 'Weather events',
      select: 'Date and time by UTC+3'
    },
    hints: {
      first: 'First term',
      last: 'Last term',
      prev: 'Previous term',
      next: 'Next term',
      stations: 'Meteostations',
      stations_background: 'Edit background sampling',
      stations_urban: 'Select urban stations',
      fields: 'Distribution fields',
      filter: 'Netatmo filtering',

      // bottom panel
      autoscale: 'Auto-zoom',
      reset: 'Reset zoom',
      add: 'Add to plot',

      // right panel
      eventlist: 'Event list',
      search: 'Search',
      invite: 'Start typing to search'
    },
    vars: {
      meteo: {
        temperature: 'Temperature [℃]',
        humidity: 'Humidity [%]',
        pressure: 'Pressure [hPa]',
        cloud: 'Cloudiness [x/10]',
        wind: 'Wind speed [m/s]',
        prec: 'Precipitation [mm]',
        pet: 'PET comfortness [℃]',
        mrt: 'MRT comfortness [℃]',
        utci: 'UTCI comfortness [℃]'
      },
      air: {
        moscow: {
          nh3: 'Ammonia (NH<sub>3</sub>)',
          pm10: 'Susp. particles (PM<sub>10</sub>)',
          pm25: 'Susp. particles (PM<sub>25</sub>)',
          no2: 'Nitrogen dioxide (NO<sub>2</sub>)',
          so2: 'Sulfur dioxide (SO<sub>2</sub>)',
          o3: 'Ozone (O<sub>3</sub>)',
          co: 'Carbon monoxide (CO)',
          ch4: 'Methane (CH<sub>4</sub>)',
          h2s: 'Hydrogen sulfide (H<sub>2</sub>S)',
          no: 'Nitric oxide (NO)',
          c6h6: 'Benzene (C<sub>6</sub>H<sub>6</sub>)',
          c10h8: 'Naphthalene (C<sub>10</sub>H<sub>8</sub>)',
          c8h8: 'Styrene (C<sub>8</sub>H<sub>8</sub>)',
          c7h8: 'Toluene (C<sub>7</sub>H<sub>8</sub>)',
          c6h5oh: 'Phenol (C<sub>6</sub>H<sub>5</sub>OH)',
          ch2o: 'Formaldehyde (CH<sub>2</sub>O)',
        },
        spb: {
          nh3: 'Ammonia (NH<sub>3</sub>)',
          susp_sol: 'Susp. solids (SS)',
          pm10: 'Susp. particles (PM<sub>10</sub>)',
          pm25: 'Susp. particles (PM<sub>25</sub>)',
          no2: 'Nitrogen dioxide (NO<sub>2</sub>)',
          so2: 'Sulfur dioxide (SO<sub>2</sub>)',
          o3: 'Ozone (O<sub>3</sub>)'
        }   
      }
    },
    periods: {
      hour: 'Term',
      day: 'Day',
      week: 'Week',
      month: 'Month',
      year: 'Year'
    },
    aggrunits: [
      { text: 'Raw data (3 h.)', value : 'hour' },
      { text: 'Day', value : 'day' },
      { text: 'Week', value : 'week' },
      { text: 'Month', value : 'month' },
      { text: 'Year', value : 'year' }
    ],
    cities: [
      { text: 'Moscow', value : 'moscow' },
      { text: 'Saint Petersburg', value : 'spb' },
    ],
    messages: {
      no_background_data: 'No background data available',
      confidence_hint: 'Reduce confidence to {confidence}% to see data?',
      yes: 'Yes',
    },
            fields: {
      name: 'NAME_EN',
      stname: 'name_en'
    },
    grades: {
      extreme_heat_stress: 'Extreme heat stress',
      very_high_heat_stress: 'Very high heat stress',
      high_heat_stress: 'High heat stress',
      moderate_heat_stress: 'Moderate heat stress',
      no_thermal_stress: 'Thermal comfort',
      moderate_cold_stress: 'Moderate cold stress',
      high_cold_stress: 'High cold stress',
      very_high_cold_stress: 'Very high cold stress',
      extreme_cold_stress: 'Extreme cold stress'
    },
    pdk: {
      label: 'MAC (daily average)',
      fraction: 'MAC fraction'
    },
    templates: {
      network: 'Network',
      add: 'ADD TO PLOT',
      rhm: {
        title: 'Roshydromet',
        units: {
          name: '',
          id: '',
          date: '',
          time: 'h.',
          temperature: '℃',
          humidity: '%',
          pressure: 'hPa',
          cloud: '/ 10',
          wind: 'm/s',
          prec: 'mm',
          pet: '℃',
          mrt: '℃',
          utci: '℃',
        },
        labels: {
          name: 'Name',
          id: 'Identifier',
          date: 'Date',
          time: 'Time',
          temperature: 'Temperature',
          humidity: 'Humidity',
          pressure: 'Pressure',
          cloud: 'Cloudiness',
          wind: 'Wind',
          prec: 'Precipitation',
          pet: 'PET Comfortness',
          mrt: 'MRT Comfortness',
          utci: 'UTCI Comfortness',
        }
      },
      netatmo: {
        title: 'Netatmo',
        units: {
          id: '',
          date: '',
          time: 'h.',
          temperature: '℃',
          humidity: '%',
          pressure: 'hPa',
        },
        labels: {
          id: 'Identifier',
          date: 'Date',
          time: 'Time',
          temperature: 'Temperature',
          humidity: 'Humidity',
          pressure: 'Pressure',
        }
      }
    },
  }
}

// Create VueI18n instance with options
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'en', // set locale
  messages, // set locale messages
})

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
